import React from 'react';

export const DeleteIcon = ({
  width = 22,
  height = 22,
  className,
  style,
  mainFill = '#1C452B',
  accentFill = '#E1F4D3',
  ...rest
}) => {
  const size = typeof width === 'number' ? width : 22;
  const sizeH = typeof height === 'number' ? height : 22;
  const combinedStyle = {
    width: size,
    height: sizeH,
    minWidth: size,
    minHeight: sizeH,
    flexShrink: 0,
    ...style,
  };
  return (
    <svg
      width={size}
      height={sizeH}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={combinedStyle}
      {...rest}
    >
      <g clipPath="url(#clip0_delete_icon)">
        <mask id="mask0_delete_icon" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="67" height="67">
          <path d="M66.27 0H0V66.27H66.27V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_delete_icon)">
          <path d="M57.9864 18.5845C57.9311 18.5845 57.8483 18.5845 57.7655 18.5845C43.1585 17.121 28.5791 16.5688 14.1378 18.0322L8.50484 18.5845C7.34512 18.6949 6.32345 17.8666 6.213 16.7068C6.10255 15.5471 6.93093 14.5531 8.06304 14.4426L13.696 13.8904C28.3858 12.3993 43.2689 12.9792 58.1796 14.4426C59.3118 14.5531 60.1401 15.5747 60.0297 16.7068C59.9468 17.7837 59.0356 18.5845 57.9864 18.5845Z" fill={mainFill} />
          <path d="M42.7992 15.1869H22.0898L24.8511 9.66439L27.6123 6.90314H41.4186L42.7992 15.1869Z" fill={accentFill} />
          <path d="M23.4714 15.7944C23.361 15.7944 23.2505 15.7944 23.1125 15.7668C22.008 15.5735 21.2348 14.4966 21.4281 13.3921L22.0356 9.77486C22.4774 7.12406 23.0848 3.4516 29.5185 3.4516H36.753C43.2143 3.4516 43.8218 7.26212 44.236 9.80247L44.8435 13.3921C45.0367 14.5242 44.2636 15.6011 43.1591 15.7668C42.027 15.9601 40.9501 15.1869 40.7844 14.0824L40.1769 10.4928C39.7904 8.0905 39.7075 7.62108 36.7806 7.62108H29.5461C26.6192 7.62108 26.564 8.00766 26.1498 10.4652L25.5147 14.0548C25.3491 15.0765 24.4655 15.7944 23.4714 15.7944Z" fill={mainFill} />
          <path d="M41.998 62.8173H24.2708C14.6341 62.8173 14.2475 57.4881 13.9437 53.1805L12.1489 25.3747C12.0661 24.2426 12.9497 23.2486 14.0818 23.1657C15.2415 23.1105 16.208 23.9665 16.2908 25.0986L18.0856 52.9044C18.3894 57.1015 18.4998 58.6754 24.2708 58.6754H41.998C47.7966 58.6754 47.9071 57.1015 48.1832 52.9044L49.978 25.0986C50.0609 23.9665 51.0549 23.1105 52.187 23.1657C53.3191 23.2486 54.2027 24.215 54.1199 25.3747L52.3251 53.1805C52.0214 57.4881 51.6348 62.8173 41.998 62.8173Z" fill={mainFill} />
          <path d="M37.7191 47.6316H28.5241C27.3919 47.6316 26.4531 46.6927 26.4531 45.5606C26.4531 44.4285 27.3919 43.4897 28.5241 43.4897H37.7191C38.8512 43.4897 39.79 44.4285 39.79 45.5606C39.79 46.6927 38.8512 47.6316 37.7191 47.6316Z" fill={mainFill} />
          <path d="M40.0383 36.5866H26.2321C25.1 36.5866 24.1611 35.6478 24.1611 34.5156C24.1611 33.3835 25.1 32.4447 26.2321 32.4447H40.0383C41.1704 32.4447 42.1092 33.3835 42.1092 34.5156C42.1092 35.6478 41.1704 36.5866 40.0383 36.5866Z" fill={mainFill} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_delete_icon">
          <rect width="66.27" height="66.27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
